import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray300, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { GOOGLE_COPYRIGHT_IMAGE } from './constants';
export const DropDownListHolderStyled = styled.div `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: -10px;
  position: absolute;
  top: 100%;

  border: 1px solid ${colorCoreGray300};
  background-color: ${colorCoreWhite1000};
  z-index: ${Z_INDEX.level1};

  border-radius: ${CORNER_RADIUS.m};
  display: ${({ isExpandedDropDown }) => (isExpandedDropDown ? 'flex' : 'none')};
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const DropDownListStyled = styled.ul `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  width: 100%;
  list-style: none;

  box-shadow: ${elevationBottomLvl2};
  border-radius: ${CORNER_RADIUS.m};

  ${({ withScroll }) => (withScroll ? CustomScroll : 'padding: 6px;')}

  &::after {
    content: '';
    padding: 0;
    margin: 5px 0 0;
    height: 18px;
    box-sizing: border-box;
    text-align: right;
    display: block;
    background-image: url(${GOOGLE_COPYRIGHT_IMAGE});
    background-position: right;
    background-repeat: no-repeat;
    background-size: 120px 14px;
  }
`;
export const ItemOptionStyled = styled.li `
  display: flex;
  flex-direction: row;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  padding: 10px 12px;
  width: 100%;
  cursor: pointer;
  text-transform: capitalize;

  border-radius: ${CORNER_RADIUS.xs};
  color: ${colorCoreBlack900Base};

  background-color: ${({ isActiveEntity }) => isActiveEntity ? colorBlackTransparent50 : defaultTransparent};

  background-color: ${({ isHovered }) => isHovered ? colorBlackTransparent50 : defaultTransparent};

  &:hover {
    background-color: ${colorCoreGray300};
  }
`;
export const RegularTextLevel4Styled = styled(RegularTextLevel4) `
  margin: 0 4px 0 0;
`;
